import { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import priceListActions from "../../../store/actions/items/prices/price.actions";

export const AddPriceListPageComponent = ({ priceListActions }) => {
  const [priceListDetails, setPriceListDetails] = useState({ name: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPriceListDetails({ ...priceListDetails, [name]: value });
  };

  const handleAddPriceList = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await priceListActions.addPriceList(priceListDetails);
      alert("Price list added successfully!");
      setPriceListDetails({ name: "" }); // Reset form
    } catch (error) {
      console.error("Error adding price list:", error);
      setError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <h2>Add Price List</h2>
      <form onSubmit={handleAddPriceList}>
        <div>
          <label htmlFor="name">Price List Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={priceListDetails.name}
            onChange={handleInputChange}
            disabled={isSubmitting}
            required
          />
        </div>
        {error && <p style={{ color: "red" }}>Error: {error.message || "Failed to add price list"}</p>}
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Adding..." : "Add Price List"}
        </button>
      </form>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    priceListActions: bindActionCreators(priceListActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(AddPriceListPageComponent);
